// src/components/MobileBottomNav.jsx
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import MobileCategoriesDrawer from "./MobileCategoriesDrawer";
import { useCart } from "../context/CartContext";
import { useFavorites } from "../context/FavoritesContext";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import {
  FaHome,
  FaThLarge,
  FaShoppingBag,
  FaUser,
  FaHeart,
} from "react-icons/fa";

export default function MobileBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const { cartItems } = useCart();
  const { favorites } = useFavorites(); // ✅ FAVORITES CONTEXT

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    const unsub = onAuthStateChanged(auth, (u) => setUser(u));
    return () => unsub();
  }, []);

  // Ürün detay sayfasında alt menüyü gizle
  if (location.pathname.startsWith("/product/")) {
    return null;
  }

  const goLink = (path) => {
    setDrawerOpen(false);
    navigate(path);
  };

  // Sepet butonu direkt sayfaya yönlendiriyor
  const handleCartClick = () => {
    setDrawerOpen(false);
    navigate("/cart");
  };

  // ✅ SEPET SAYISI
  const totalCount =
    cartItems?.reduce((acc, item) => acc + (item.quantity || 1), 0) || 0;

  // ✅ FAVORİ SAYISI
  const favoriteCount = favorites?.length || 0;

  const navItems = [
    {
      id: "home",
      label: "Anasayfa",
      icon: <FaHome size={20} />,
      action: () => goLink("/"),
      isActive: location.pathname === "/",
    },
    {
      id: "categories",
      label: "Kategoriler",
      icon: <FaThLarge size={19} />,
      action: () => setDrawerOpen(true),
      isActive: drawerOpen,
    },
    {
      id: "cart",
      label: "Sepetim",
      icon: <FaShoppingBag size={20} />,
      action: handleCartClick,
      isActive: location.pathname === "/cart",
      badge: totalCount > 0 ? (totalCount > 99 ? "99+" : totalCount) : null,
    },
    {
      id: "favorites",
      label: "Favorilerim",
      icon: <FaHeart size={19} />,
      action: () => goLink("/favorites"),
      isActive: location.pathname === "/favorites",
      badge:
        favoriteCount > 0
          ? favoriteCount > 99
            ? "99+"
            : favoriteCount
          : null,
    },
    {
      id: "account",
      label: "Hesabım",
      icon: <FaUser size={19} />,
      action: () => goLink(user ? "/profile" : "/login"),
      isActive:
        location.pathname === "/profile" ||
        location.pathname === "/login",
    },
  ];

  return (
    <>
      <MobileCategoriesDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      />

      <nav className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-white border-t border-gray-100 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] pb-safe">
        <div className="flex justify-around items-center h-[60px]">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={item.action}
              className={`relative flex-1 flex flex-col items-center justify-center h-full transition-all duration-200 active:scale-95 ${
                item.isActive
                  ? "text-[#6A0DAD]"
                  : "text-gray-400 hover:text-gray-600"
              }`}
            >
              <div
                className={`mb-1 transition-transform duration-200 ${
                  item.isActive ? "-translate-y-0.5" : ""
                }`}
              >
                {item.icon}
              </div>

              <span
                className={`text-[10px] font-bold ${
                  item.isActive
                    ? "text-[#6A0DAD]"
                    : "text-gray-500"
                }`}
              >
                {item.label}
              </span>

              {/* ✅ BADGE */}
              {item.badge && (
                <span className="absolute top-1 right-[22%] min-w-[18px] h-[18px] px-1 bg-red-500 text-white text-[9px] font-bold flex items-center justify-center rounded-full border-2 border-white shadow-sm leading-none">
                  {item.badge}
                </span>
              )}
            </button>
          ))}
        </div>
      </nav>
    </>
  );
}